module.exports = __webpack_public_path__ + "static/media/notik.11f6ec2f.jpg";